import { HSLColor } from "react-color";
import { HSLColors } from "../../../../services/UI/Background/Texture/Helpers/HSLColor";

export function GetLifeChangingEventFloorColor(perspective: number): HSLColor {
    const alphaOffset = GetAlphaOffset(perspective);

    if (perspective <= 2.5)
        return { h: 103, s: 100, l: 73, a: 0.25 - alphaOffset };

    if (perspective <= 4.5)
        return { h: 211, s: 100, l: 74, a: 0.25 - alphaOffset };

    if (perspective <= 6.5)
        return { h: 294, s: 86, l: 74, a: 0.25 - alphaOffset };

    if (perspective <= 8.5)
        return { h: 20, s: 86, l: 74, a: 0.25 - alphaOffset };

    return HSLColors.black;
}

function GetAlphaOffset(perspective: number) {
    if (perspective % 2 == 1) return 0.225; // first season
    if (perspective % 2 == 1.5) return 0.15; // second season
    if (perspective % 2 == 0) return 0.075; // third season
    return 0; // fourth season
}
